import $ from 'jquery'

import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/tooltip'

import tile from './tiles'
import icon from './icon'
import newsteaser from './newsteaser'
import assetSlider from './asset-slider'
import portfolio from './portfolio'
import storytelling from './storytelling'
import footer from './footer'
import inpageNavigation from './in-page-navigation'
import eventOverview from './event-overview'
import linkDownloadList from './link-download-list'
import newsOverview from './news-overview'
import tabTextImage from './tab-text-image'
import factoringtest from './factoringtest'
import leasingtest from './leasingtest'
import stickyNavigation from './sticky-navigation'
import accordion from './accordion'
import corporateFacts from './corporate-facts'
import animateInputPlaceholder from './animate-input-placeholder'
import contactDetail from './contact-detail'
import contactDropdown from './contact-dropdown'
import locationFinderLoader from './location-finder-loader'
import comparisonTable from './comparison-table'
import interimExplorer from './interim-explorer'
import solutionFinder from './solution-finder'
import suggestion from './suggestion'
import optout from './optout'
import tracking from './tracking'
import teamwall from './teamwall'
import glossary from './glossary'
import calculator from '../../campaign/scripts/fgs/calculator'
import eloquaForm from './eloqua-form'
import tabsearch from './tab-search'
import cashflowOptimizerCalculator from './cashflow-optimizer-calculator'
import leasingCalculator from './leasing-calculator/leasing-calculator'
import internationalLeasingCalculator from './international-leasing-calculator/international-leasing-calculator'
import dataProtection from './data-protection'
import contactTeaser from './contact-teaser'
import youtubeIframe from './youtubeIframe'
import videoModals from './videoModals'
import { updateSessionStorage } from './updateSessionStorage'
import { positionImages } from './positionImages'
import diagrams from './diagrams'
import kpis from './kpis'
import eloquaFormValidation from './eloqua-form-with-layout/validation'
import focuspoints from './focuspoint'
import colorBox from './color-box'

// Component callback registry for edit-mode refresh
const componentRefreshCallbacks = {}

// Function to register callback for a component
const registerComponentRefreshCallback = (componentName, callbackFunction) => {
  if (typeof callbackFunction === 'function') {
    componentRefreshCallbacks[componentName] = callbackFunction
  }
}

const initializeApplication = async () => {
  // function for history-back
  $('#btn-history-back').on('click', function () {
    window.history.back()
  })

  if (location.hash) {
    window.scrollTo(0, 0)
  }
  /* TODO for testing */

  $('.grenke-bullets li').each(function () {
    const newText = $(this).html()
    $(this).text('')
    $(this).append('<span class="text-wrap">' + newText + '</span>')
  })

  /* ToDo Better Solution */
  $(document).on('infiniteScrolling', function () {
    $('.img-fill').each(function () {
      positionImages($(this))
      $(this).find('.hide-while-load').removeClass('hide-while-load')
    })
    $('.grenke-bullets li').each(function () {
      const newText = $(this).text()
      $(this).text('')
      $(this).append('<span class="text-wrap">' + newText + '</span>')
    })
    newsteaser.init()
  })
  /* TODO status test: shows img in news teaser after recalculating sizes */
  $(document).find('.hide-while-load').removeClass('hide-while-load')

  $('body').on('click', 'a[href*="#"]', function (e) {
    const currentPath = window.location.pathname
    const targetUrl = $.attr(this, 'href').split('#')[0]

    if (currentPath === targetUrl) {
      e.preventDefault()
      const el = $($(this).prop('hash').replace('#', '#_'))
      if (el.length > 0) {
        $('html, body').animate(
          {
            scrollTop: el.offset().top - 150,
          },
          1000,
          'linear'
        )
      }
      return false
    }
  })

  // add functions to window for reInit Components in editMode
  if (window.editMode) {
    window.reInitHandling = {}

    window.reInitHandling.assetSlider = assetSlider
  }

  $(window).on('load', function () {
    if (location.hash) {
      setTimeout(function () {
        const href = location.hash
        const _href = href.replace('#', '#_')
        const el = $(_href)

        if (el.length > 0) {
          $('html, body').animate(
            {
              scrollTop: el.offset().top - 150,
            },
            1000,
            'linear'
          )
        }
      }, 1)
    }
  })

  window.addEventListener('OneTrustGroupsUpdated', function () {
    updateSessionStorage()
    contactDetail.init()
    eloquaForm.init()
  })

  window.addEventListener('component-edit-refresh', function (event) {
    const componentName = event.detail?.componentName
    if (componentName && componentRefreshCallbacks[componentName]) {
      componentRefreshCallbacks[componentName](event.detail?.sectionElement)
    }
  })
}

const initializeComponents = async () => {
  const components = [
    assetSlider,
    footer,
    icon,
    tile,
    newsteaser,
    portfolio,
    storytelling,
    inpageNavigation,
    eventOverview,
    animateInputPlaceholder,
    linkDownloadList,
    newsOverview,
    tabTextImage,
    factoringtest,
    leasingtest,
    stickyNavigation,
    accordion,
    corporateFacts,
    contactDetail,
    contactDropdown,
    locationFinderLoader,
    comparisonTable,
    interimExplorer,
    solutionFinder,
    suggestion,
    optout,
    teamwall,
    glossary,
    dataProtection,
    contactTeaser,
    calculator,
    eloquaForm,
    tabsearch,
    cashflowOptimizerCalculator,
    internationalLeasingCalculator,
    leasingCalculator,
    youtubeIframe,
    videoModals,
    diagrams,
    kpis,
    eloquaFormValidation,
    focuspoints,
    colorBox
  ]

  for (const component of components) {
    await component.init(registerComponentRefreshCallback)
  }
  tracking.init(origin.split('//')[1])
}

$(document).ready(async function () {
  await initializeApplication()
  await initializeComponents()
})
